import { profanities } from "profanities";

const moreWords = ["twat"];

export const profanityList = profanities.concat(moreWords);
